module.exports = __webpack_public_path__ + "img/persona dreamdeal tech (3)-25.09075593.png";